import * as React from "react";
import { FC, useEffect } from "react";

import { SingleTreeNode } from "../TreePicklistNode/SingleTreeNode";
import { TreePicklistItem } from "../TreePicklistItem";
import { useResetVisibleChildrenCount } from "../TreePicklistNode/VisibleElementsCountProvider";
import { isNotNullOrEmpty } from "../../../../../../../Common/TypingUtils";

import { PicklistModalProps } from "./TreePicklistModal";

export const SingleTree: FC<{
    items: TreePicklistItem[];
    searchQuery: string;
    modalProps: PicklistModalProps;
    needNodesToOpen: TreePicklistItem[];
    onLoadingError: () => void;
}> = ({ items, searchQuery, modalProps, needNodesToOpen, onLoadingError }) => {
    const searchMode = isNotNullOrEmpty(searchQuery);

    const resetVisibleChildrenCount = useResetVisibleChildrenCount();
    useEffect(() => {
        resetVisibleChildrenCount();
    }, [searchQuery]);

    const updateNodesToSave = (item: TreePicklistItem) => {
        modalProps.onSave([item.toOriginal()]);
        modalProps.onClose();
    };

    return (
        <>
            {items.map(item => (
                <SingleTreeNode
                    {...modalProps}
                    key={item.elementId}
                    item={item}
                    nestingLevel={1}
                    searchMode={searchMode}
                    needNodesToOpen={needNodesToOpen}
                    updateNodesToSave={updateNodesToSave}
                    onLoadingError={onLoadingError}
                />
            ))}
        </>
    );
};
